import useCoreModelsFindAll from '../../../hooks/useCoreModelsFindAll'

export default function usePatrolRouteRuns(query = { where: {} }, opts) {
  return useCoreModelsFindAll('patrolRouteRun', {
    orderBy: ['status', ['updatedAt', 'desc']],
    ...query
  }, opts)
}
